<i2g-router-link
  type="master-list-item-link"
  [disabled]="route?.disabled"
  [route]="route?.route"
  [navigationExtras]="route?.navigationExtras"
  [e2eId]="route?.e2eId"
  [trackingObject]="route?.trackingObject || trackingObject"
  [trackingAction]="route?.trackingAction || trackingAction"
  [trackingAdditionalProperties]="
    route?.trackingAdditionalProperties || trackingAdditionalProperties
  "
>
  <div
    class="content"
    [ngClass]="{ 'bulk-actions-enabled': !!bulkActionControl }"
  >
    <div *ngIf="bulkActionControl" class="data-cell bulk-action-control">
      <div class="data-cell-contents-wrapper">
        <span class="data-cell-contents">
          <app-checkbox-field
            [hideLabel]="true"
            e2eId="bulk-select-field"
            fieldId="bulk_select_{{ id }}_field"
            [fieldControl]="bulkActionControl"
            trackingIdentifier="bulk_action"
            [trackingObject]="route.trackingObject"
            [trackingScreenName]="trackingScreenName"
            [trackingAdditionalProperties]="trackingAdditionalProperties"
            (onClick)="onBulkActionClick($event)"
          >
          </app-checkbox-field>
        </span>
      </div>
    </div>

    <div
      *ngFor="let data of entityData; let entityDataPos = index"
      class="data-cell {{ data.customClass }}"
      [attr.data-e2e-id]="data.e2eId"
      [attr.data-e2e-value]="data.e2eValue"
    >
      <div *ngIf="data.leftIcons" class="icons-container">
        <app-icon
          *ngFor="let leftIcon of data.leftIcons"
          class="icon left-icon"
          [icon]="leftIcon"
        >
        </app-icon>
      </div>

      <div class="data-cell-contents-wrapper">
        <span
          *ngFor="let tokenValues of tokenizedValues.get(entityDataPos)"
          class="data-cell-contents"
          [ngClass]="{ 'single-line': !data.truncateThreshold }"
          [multiLineTruncate]="data.truncateThreshold"
        >
          <span
            *ngFor="let token of tokenValues"
            class="token-value"
            [ngClass]="{ highlighted: token.highlighted }"
            [ngSwitch]="token.isHtml"
            ><ng-container *ngSwitchCase="true"
              ><span
                [innerHTML]="token.value | safe: 'html'"
              ></span></ng-container
            ><ng-container *ngSwitchDefault>{{
              token.value
            }}</ng-container></span
          >
        </span>
      </div>

      <div *ngIf="data.rightIcons" class="icons-container">
        <app-icon
          *ngFor="let rightIcon of data.rightIcons"
          class="icon right-icon"
          [icon]="rightIcon"
        >
        </app-icon>
      </div>
    </div>
  </div>

  <app-dropdown
    *ngIf="actions; else actionPlaceholder"
    class="actions"
    [e2eId]="dropdownE2eId"
    [horizontalAlignment]="actionsHorizontalAlignment"
    [dropdownGroupedItems]="actions"
    [stopClickPropagation]="true"
  >
    <ng-template let-closeCallback="closeCallback" let-action="dropdownItem">
      <button
        type="button"
        class="action {{ action.customClass }}"
        [ngClass]="{ 'delete-action': action.deleteAction }"
        [attr.data-e2e-id]="action.e2eId"
        trackable
        [trackingObject]="action.trackingObject"
        [trackingAction]="action.trackingAction"
        [trackingAdditionalProperties]="action.trackingAdditionalProperties"
        (click)="onQuickAction($event, action); closeCallback()"
      >
        {{ action.label }}
      </button>
    </ng-template>
  </app-dropdown>

  <ng-template #actionPlaceholder>
    <div class="action-placeholder"></div>
  </ng-template>
</i2g-router-link>
